import React from 'react';

const TeamHero = () => {
  return (
    <section className="team-hero">
      <div className="team-hero-container">
        <h1 className="team-hero-title">
          Experts in Essential Real Estate
        </h1>
        <p className="team-hero-subtitle">
          We combine disciplined deal-making, institutional operations, and modern on-chain rails to protect and grow investor capital
        </p>
      </div>
    </section>
  );
};

export default TeamHero;
